
import { ElTable } from "element-ui/types/table";
import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { Patient } from "../../../../domain/patient";
import { ModelEditableMixin } from "../../../system/mixins";

@Component
export default class DuplicatedPatientSelectorMixin extends Mixins(ModelEditableMixin) {
  data(): any {
    return {
      patients: [] as Patient[],
      isFinding: false,
      isUpdating: false,
    };
  }
  patients: Patient[];
  isFinding: boolean;
  isUpdating: boolean;

  $refs!: {
    table: ElTable,
  };

  @Prop()
  isVisible: boolean;

  @Prop()
  sourceId: string;

  @Watch("isVisible")
  onIsVisibleChanged(newValue: boolean): void {
    if (newValue) {
      this.setCurrentRow(this.sourceId);
    }
  }

  @Watch("patients")
  onPatientsUpdated(newValue: Patient, oldValue: Patient): void {
    if (newValue && newValue !== oldValue) {
      this.setCurrentRow(this.sourceId);
    }
  }

  setCurrentRow(sourceId: string) {
    if (!sourceId || (!this.patients || this.patients.length === 0) || !this.$refs.table) { return; }
    const selectedPatient = this.patients.find(p => p.id === sourceId);
    this.$refs.table.setCurrentRow(selectedPatient);
    this.onRowClicked(selectedPatient);
  }

  clearInformation(): void {
    this.editingSource = null;
    this.patients = [];
  }

  get isFound(): boolean {
    return !this.isFinding && !!this.patients.length;
  }

  onRowClicked(row: Patient): void {
    this.editingSource = row;
    
    // IEで選択行の背景色が正常に描画反映しないため、ダミーのカラムサイズを一瞬表示切り替えて強制的に再描画させている
    // 京大は新Edgeになるはずなので現地では問題ない見込み
    this.isUpdating = true;
    this.$sleep(500)
    .then(() => {
      this.isUpdating = false;
    });
  }

  onRowDoubleClicked(row: Patient): void {
    this.editingSource = row;
    this.dblclick(row);
  }

  @Emit()
  dblclick(row: Patient): void {}

  isSourceId(id: string): boolean {
    return (this.sourceId === id);
  }
}
